import {byClassAll} from "./dom-utils";


const cBase = 'date'
const cPrePulse = `${cBase}--pre-pulse`
const cPulse = `${cBase}--pulse`


function unpulse(date) {
    date.classList.remove(cPulse)
}

function pulseOne(date) {
    date.classList.add(cPulse)
    date.classList.remove(cPrePulse)
    setTimeout(unpulse, 1800, date)
}

function pulseAll(dates) {
    if (document.documentElement.scrollTop > window.innerHeight) {
        console.debug('initPulse : pulse all : skipping')
        return
    }

    console.debug('initPulse : pulse all')
    dates.forEach((d, i) => {
        d.classList.add(cPrePulse)
        setTimeout(pulseOne, i * 50, d)
    })
}


export function initPulse() {
    console.debug('initPulse')
    const dates = Array.from(byClassAll(cBase))
    setInterval(pulseAll, 7000, dates)
    pulseAll(dates)
}